import React from 'react';

import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

type Props = {
  type?: string;
  width?: string;
  height?: string;
  className?: string;
};

const CharmaLogo = (props: Props) => {
  let logo = Illustrations.pi_logo_full_red_with_text;
  if (props.type === 'icon') {
    logo = Illustrations.pi_logo_circle_red;
  }
  if (props.type === 'long-white') {
    logo = Illustrations.pi_logo_full_white_with_text;
  }

  return <WpIllustration src={logo} alt="Predictive Index logo" {...props} />;
};

export default CharmaLogo;
